import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Grid,
  Box,
  CircularProgress,
  Alert,
  FormControl,
  InputLabel,
  Select,
  Chip,
  Typography,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../api/api";
import { ENDPOINTS } from "../../api/endpoints";
import Navbar from "../../talent/NavigationTalent";
import Section from "../../components/FormSection";
import CityAutocomplete from "../components/CityAutocomplete";
import PageInstructions from "../components/PageInstructions";
import GlobalNotification from "../../components/GlobalNotification";
import Footer from "../../Footer";
import PhoneNumberField from "../../components/common/PhoneNumberField";

/* ---------------- CONSTANTS ---------------- */

const SEX_OPTIONS = [
  "Male",
  "Female",
  "Trans Female",
  "Trans Male",
  "Non-Binary",
];

/* ---------------- HELPERS ---------------- */

const unwrap = (res) => {
  if (!res) return null;

  if (Array.isArray(res)) return res;

  if (Array.isArray(res?.data?.data)) return res.data.data;

  if (Array.isArray(res?.data)) return res.data;

  if (res?.data?.data) return res.data.data;

  if (res?.data) return res.data;

  return res;
};
const normalizePhoneNumber = (value = "") => {
  if (!value) return "";

  return String(value).trim();
};

const getLocalPhoneNumber = (value = "") => {
  if (!value) return "";

  return String(value).trim();
};

const isValidPhone = (value = "") => {
  const localNumber = getLocalPhoneNumber(value);

  return localNumber.replace(/\D/g, "").length >= 7;
};

// Remove keys with undefined so we only send valid swagger fields
const stripUndefined = (obj) => {
  const out = { ...obj };
  Object.keys(out).forEach((k) => out[k] === undefined && delete out[k]);
  return out;
};

/* ---------------- COMPONENT ---------------- */

const ProfilePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [measurementsOpen, setMeasurementsOpen] = useState(false);
  const [userId, setUserId] = useState(null);
  useEffect(() => {
    setUserId(localStorage.getItem("userId"));
  }, []);
  const userRole = localStorage.getItem("userRole");

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const [originalProfile, setOriginalProfile] = useState({});
  const [originalTalentIds, setOriginalTalentIds] = useState([]);
  const [originalRepresentations, setOriginalRepresentations] = useState({});
  const [ethnicityOptions, setEthnicityOptions] = useState([]);
const [primaryPhoneLocked, setPrimaryPhoneLocked] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    sex: "",
    ethnicityCode: "",
    city: "",
    stateName: "",
    stateCode: "",
    primaryPhone: "",
    secondaryPhone: "",
    email: "",
    faceBook: "",
    instagram: "",
    tikTok: "",
    youTube: "",
    imdb: "",
    snapChat: "",
    personalWebSite: "",
    ageRangeFrom: "",
    ageRangeTo: "",
    paymentDetails: [
      { label: "", link: "" },
      { label: "", link: "" },
      { label: "", link: "" },
    ],
  });

  const [talentTypeOptions, setTalentTypeOptions] = useState([]);
  const [selectedTalentIds, setSelectedTalentIds] = useState([]);

  const [errors, setErrors] = useState({});
  const [repErrors, setRepErrors] = useState({});
  const [mandatoryErrors, setMandatoryErrors] = useState({});

  /* REPRESENTATION */
  const [repHeadings, setRepHeadings] = useState([]);
  const [representations, setRepresentations] = useState({});

  /* ---------------- LOAD DATA ---------------- */

  useEffect(() => {
    if (!userId) return;

    const loadData = async () => {
      try {
        const [profileRes, userTalentsRes, talentListRes, headingsRes,ethnicityRes] =
          await Promise.all([
            api.get(ENDPOINTS.getTalentProfileDetails({ userId })),
            api.get(ENDPOINTS.getUserTalents({ userId })),
            api.get(ENDPOINTS.getActiveTalents()),
            api.get(ENDPOINTS.getAllRepresentationHeadings()),
            api.get(ENDPOINTS.getEthnicityOptions()),
          ]);

        const apiProfile = unwrap(profileRes);
        setOriginalProfile(apiProfile);
        setPrimaryPhoneLocked(
  isValidPhone(apiProfile.primaryContactNumber || "")
);
        setFormData({
          firstName: apiProfile.firstName || "",
          middleName: apiProfile.middleName || "",
          lastName: apiProfile.lastName || "",
          sex: apiProfile.sex || "",
          ethnicityCode: apiProfile.ethnicityCode || "",
          city: apiProfile.city || "",
stateName: apiProfile.location || apiProfile.stateCode || "",

          stateCode: apiProfile.stateCode || "",
          primaryPhone: normalizePhoneNumber(
  apiProfile.primaryContactNumber || ""
),

secondaryPhone: normalizePhoneNumber(
  apiProfile.secondaryContactNumber || ""
),
          email: apiProfile.email || "",
          faceBook: apiProfile.faceBook || "",
          youTube: apiProfile.youTube || "",
          imdb: apiProfile.imdb || "",
          snapChat: apiProfile.snapChat || "",
          instagram: apiProfile.instagram || "",
          tikTok: apiProfile.tikTok || "",
          personalWebSite: apiProfile.personalWebSite || "",
          ageRangeFrom:
            apiProfile.ageRangeFrom !== null &&
            apiProfile.ageRangeFrom !== undefined
              ? apiProfile.ageRangeFrom
              : "",
          ageRangeTo:
            apiProfile.ageRangeTo !== null &&
            apiProfile.ageRangeTo !== undefined
              ? apiProfile.ageRangeTo
              : "",

          // ADD THIS
          paymentDetails: [
            {
              label: apiProfile.paymentLabel1 || "",
              link: apiProfile.paymentLink1 || "",
            },
            {
              label: apiProfile.paymentLabel2 || "",
              link: apiProfile.paymentLink2 || "",
            },
            {
              label: apiProfile.paymentLabel3 || "",
              link: apiProfile.paymentLink3 || "",
            },
          ],
        });

        const talents = unwrap(talentListRes);
        setTalentTypeOptions(
          Array.isArray(talents)
            ? talents.filter((t) => t.activeFlag !== false)
            : [],
        );
        const userTalents = unwrap(userTalentsRes);
  const ethnicities = unwrap(ethnicityRes);

setEthnicityOptions(
    Array.isArray(ethnicities)
        ? ethnicities.filter(e => e.activeFlag)
        : []
);
        const userTalentIds = Array.isArray(userTalents)
          ? userTalents
              .filter((t) => t.activeFlag !== false)
              .map((t) => t.idnTalent)
          : [];

        setSelectedTalentIds(userTalentIds);
        setOriginalTalentIds(userTalentIds); // NEW
        const rawHeadings = unwrap(headingsRes);
        const normalizedHeadings = Array.isArray(rawHeadings)
          ? rawHeadings.filter((h) => h.active).map((h) => h.headingName)
          : [];

        setRepHeadings(normalizedHeadings);

        const repData = {};
        await Promise.all(
          normalizedHeadings.map(async (h) => {
            const res = await api.get(
              ENDPOINTS.getRepresentationInformation(userId, h),
            );
            const info = Array.isArray(res.data)
              ? res.data[0] || {}
              : res.data || {};

            repData[h] = {
              nameofCompany: info.nameofCompany || "",
              representativeName: info.representativeName || "",
              representativeContact: normalizePhoneNumber(
  info.representativeContact || "",
),
            };
          }),
        );

        setRepresentations(repData);
        setOriginalRepresentations(repData); // NEW
      } catch (err) {
        console.error("Error loading profile data", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [userId]);


  /* ---------------- HANDLERS ---------------- */

  const handleChange = (e) => {
  const { name, value } = e.target;

  const finalValue = value;

  setFormData((prev) => ({
    ...prev,
    [name]: finalValue,
  }));

  setSaved(false);

  // Clear mandatory errors when user fixes the field
  setMandatoryErrors((prev) => {
    const updated = { ...prev };

    if (name === "firstName" && finalValue.trim()) {
      delete updated.firstName;
    }

    if (name === "lastName" && finalValue.trim()) {
      delete updated.lastName;
    }

    if (name === "sex" && finalValue) {
      delete updated.sex;
    }
if (name === "ethnicityCode" && finalValue) {
  delete updated.ethnicityCode;
}
    if (name === "ageRangeFrom" && finalValue !== "") {
      delete updated.ageRangeFrom;
    }

    if (name === "ageRangeTo" && finalValue !== "") {
      delete updated.ageRangeTo;
    }

    return updated;
  });
};
  const handlePaymentChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.paymentDetails];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return { ...prev, paymentDetails: updated };
    });

    setSaved(false);
  };
const handleRepChange = (heading, field, value) => {
  const finalValue = value;

  setRepresentations((prev) => ({
    ...prev,
    [heading]: {
      ...prev[heading],
      [field]: finalValue,
    },
  }));

  if (field === "representativeContact") {
    setRepErrors((prev) => ({
      ...prev,
      [heading]:
        finalValue && !isValidPhone(finalValue)
          ? "Enter a valid phone number"
          : undefined,
    }));
  }

  setSaved(false);
};

  /* ---------------- VALIDATION ---------------- */

const validatePhones = () => {
  const newErrors = {};

  if (!formData.primaryPhone) {
    newErrors.primaryPhone = "Primary phone number is required";
  } else if (!isValidPhone(formData.primaryPhone)) {
    newErrors.primaryPhone = "Enter a valid phone number";
  }

  if (
    formData.secondaryPhone &&
    !isValidPhone(formData.secondaryPhone)
  ) {
    newErrors.secondaryPhone = "Enter a valid phone number";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

const validateRepresentationPhones = () => {
  const newErrors = {};

  repHeadings.forEach((h) => {
    const phone = representations[h]?.representativeContact;

    if (phone && !isValidPhone(phone)) {
      newErrors[h] = "Enter a valid phone number";
    }
  });

  setRepErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

  const validateMandatoryFields = () => {
    const errs = {};

    if (!formData.firstName?.trim()) {
      errs.firstName = "First name is required";
    }

    if (!formData.lastName?.trim()) {
      errs.lastName = "Last name is required";
    }

    if (!formData.sex) {
      errs.sex = "Sex is required";
    }
    if (!formData.ethnicityCode) {
  errs.ethnicityCode = "Ethnicity is required";
}

    if (!selectedTalentIds.length) {
      errs.talentTypes = "Select at least one talent type";
    }

    // Age validation
    if (formData.ageRangeFrom === "") {
      errs.ageRangeFrom = "Age From is required";
    }

    if (formData.ageRangeTo === "") {
      errs.ageRangeTo = "Age To is required";
    }

    // Optional but recommended: logical check
    if (
      formData.ageRangeFrom !== "" &&
      formData.ageRangeTo !== "" &&
      Number(formData.ageRangeFrom) > Number(formData.ageRangeTo)
    ) {
      errs.ageRangeTo = "Age To must be greater than or equal to Age From";
    }

    setMandatoryErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const hasRepPhoneErrors = Object.values(repErrors).some(Boolean);

  // Compare arrays (talents)
  const isTalentChanged = () => {
    const a = [...selectedTalentIds].sort();
    const b = [...originalTalentIds].sort();
    return JSON.stringify(a) !== JSON.stringify(b);
  };

  // Compare representations
  const isRepresentationChanged = () => {
    return repHeadings.some((h) => {
      const current = representations[h] || {};
      const original = originalRepresentations[h] || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    });
  };

  // Compare profile (only important fields)
  const isProfileChanged = (payload) => {
    const normalize = (obj) => JSON.stringify(stripUndefined(obj));

    const current = normalize(payload);

const original = normalize({
  userId: Number(userId),

  firstName: originalProfile.firstName || undefined,
  lastName: originalProfile.lastName || undefined,

  ageRangeFrom: originalProfile.ageRangeFrom ?? undefined,
  ageRangeTo: originalProfile.ageRangeTo ?? undefined,

  sex: originalProfile.sex || undefined,

  primaryContactNumber:
    originalProfile.primaryContactNumber || null,

  secondaryContactNumber:
    originalProfile.secondaryContactNumber || null,

  email: originalProfile.email || undefined,

  location: originalProfile.location ?? null,

  city: originalProfile.city ?? null,

  stateCode: originalProfile.stateCode ?? null,

  middleName: originalProfile.middleName || undefined,

  ethnicityCode: originalProfile.ethnicityCode ?? undefined,

  faceBook: originalProfile.faceBook || undefined,
  instagram: originalProfile.instagram || undefined,
  tikTok: originalProfile.tikTok || undefined,
  personalWebSite: originalProfile.personalWebSite || undefined,
  youTube: originalProfile.youTube || undefined,
  imdb: originalProfile.imdb || undefined,
  snapChat: originalProfile.snapChat || undefined,

  paymentLabel1: originalProfile.paymentLabel1 || null,
  paymentLink1: originalProfile.paymentLink1 || null,

  paymentLabel2: originalProfile.paymentLabel2 || null,
  paymentLink2: originalProfile.paymentLink2 || null,

  paymentLabel3: originalProfile.paymentLabel3 || null,
  paymentLink3: originalProfile.paymentLink3 || null,
});

    return current !== original;
  };

  /* ---------------- SAVE ---------------- */

  const handleSubmit = async () => {
    if (
      !validateMandatoryFields() ||
      !validatePhones() ||
      !validateRepresentationPhones()
    ) {
      return;
    }

    setSaving(true);

    try {
      const payload = stripUndefined({
        userId: Number(userId),

        // strings
        lastName: formData.lastName || undefined,
        firstName: formData.firstName || undefined,
        ageRangeFrom:
          formData.ageRangeFrom !== ""
            ? Number(formData.ageRangeFrom)
            : undefined,
        ageRangeTo:
          formData.ageRangeTo !== "" ? Number(formData.ageRangeTo) : undefined,
        sex: formData.sex || undefined,
        ethnicityCode:
    formData.ethnicityCode !== ""
        ? Number(formData.ethnicityCode)
        : undefined,

        primaryContactNumber: formData.primaryPhone
          ? String(formData.primaryPhone)
          : null,
        secondaryContactNumber: formData.secondaryPhone
          ? String(formData.secondaryPhone)
          : null,

        email: formData.email || undefined,

        location: formData.stateName,
city: formData.city,
stateCode: formData.stateCode,
        eyeColorCode:
          originalProfile.eyeColorCode !== undefined
            ? originalProfile.eyeColorCode
            : undefined,
        hairColorCode:
          originalProfile.hairColorCode !== undefined
            ? originalProfile.hairColorCode
            : undefined,
        weight:
          originalProfile.weight !== undefined
            ? originalProfile.weight
            : undefined,
        heightStart:
          originalProfile.heightStart !== undefined
            ? originalProfile.heightStart
            : undefined,
        heightEnd:
          originalProfile.heightEnd !== undefined
            ? originalProfile.heightEnd
            : undefined,
        vocalRangeID:
          originalProfile.vocalRangeID !== undefined
            ? originalProfile.vocalRangeID
            : undefined,

        dress:
          originalProfile.dress !== undefined
            ? originalProfile.dress
            : undefined,
        bust:
          originalProfile.bust !== undefined ? originalProfile.bust : undefined,
        waist:
          originalProfile.waist !== undefined
            ? originalProfile.waist
            : undefined,
        hips:
          originalProfile.hips !== undefined ? originalProfile.hips : undefined,
        shoe:
          originalProfile.shoe !== undefined ? originalProfile.shoe : undefined,

        maleSuit:
          originalProfile.maleSuit !== undefined
            ? originalProfile.maleSuit
            : undefined,
        maleShirt:
          originalProfile.maleShirt !== undefined
            ? originalProfile.maleShirt
            : undefined,
        maleWaist:
          originalProfile.maleWaist !== undefined
            ? originalProfile.maleWaist
            : undefined,
        maleInseam:
          originalProfile.maleInseam !== undefined
            ? originalProfile.maleInseam
            : undefined,
        maleShoe:
          originalProfile.maleShoe !== undefined
            ? originalProfile.maleShoe
            : undefined,

        middleName: formData.middleName || undefined,

        hasDriverLicencse:
          originalProfile.hasDriverLicencse !== undefined
            ? originalProfile.hasDriverLicencse
            : true,
        hasPassport:
          originalProfile.hasPassport !== undefined
            ? originalProfile.hasPassport
            : true,

        // social fields from form (send only if present)
        faceBook: formData.faceBook || undefined,

        instagram: formData.instagram || undefined,
        tikTok: formData.tikTok || undefined,
        personalWebSite: formData.personalWebSite || undefined,
        paymentLabel1: formData.paymentDetails[0]?.label?.trim()
          ? formData.paymentDetails[0].label
          : null,

        paymentLink1: formData.paymentDetails[0]?.link?.trim()
          ? formData.paymentDetails[0].link
          : null,

        paymentLabel2: formData.paymentDetails[1]?.label?.trim()
          ? formData.paymentDetails[1].label
          : null,

        paymentLink2: formData.paymentDetails[1]?.link?.trim()
          ? formData.paymentDetails[1].link
          : null,

        paymentLabel3: formData.paymentDetails[2]?.label?.trim()
          ? formData.paymentDetails[2].label
          : null,

        paymentLink3: formData.paymentDetails[2]?.link?.trim()
          ? formData.paymentDetails[2].link
          : null,

        youTube: formData.youTube || undefined,
        imdb: formData.imdb || undefined,
        snapChat: formData.snapChat || undefined,
        lattitude: formData.latitude ?? undefined,
        longitude: formData.longitude ?? undefined,
      });

      // PROFILE
      if (isProfileChanged(payload)) {
        console.log(" Profile changed → API call");
        await api.post(ENDPOINTS.updateTalentProfile(), payload);
      } else {
        console.log(" Profile NOT changed");
      }

      // TALENTS
      if (isTalentChanged()) {
        console.log(" Talents changed → API call");
        await api.post(ENDPOINTS.addOrUpdateTalentTypes(), {
          userId: Number(userId),
          userBy: Number(userId),
          talentIds: selectedTalentIds,
        });
      } else {
        console.log(" Talents NOT changed");
      }

      // REPRESENTATION
      const changedHeadings = repHeadings.filter((h) => {
        const current = representations[h] || {};
        const original = originalRepresentations[h] || {};
        return JSON.stringify(current) !== JSON.stringify(original);
      });

      if (changedHeadings.length > 0) {
        console.log(" Representation changed → API call");

        await Promise.all(
          changedHeadings.map((h) => {
            const r = representations[h];
            return api.post(ENDPOINTS.addOrUpdateRepresentation(), {
              userId: Number(userId),
              headingName: h,
              nameofCompany: r?.nameofCompany || "",
              representativeName: r?.representativeName || "",
              representativeContact: r?.representativeContact || null,
            });
          }),
        );
      } else {
        console.log(" Representation NOT changed");
      }
      setOriginalProfile({
        ...originalProfile,
        ...payload,
      });

      setOriginalTalentIds([...selectedTalentIds]);

      setOriginalRepresentations({ ...representations });

      setSaved(true);
    } catch (err) {
      console.error("Profile update failed", err);
    } finally {
      setSaving(false);
    }
  };

  if (!userId) return <CircularProgress />;

  /* ---------------- RENDER ---------------- */

  return (
    <>
      <Navbar />

      <Box sx={{ maxWidth: 1200, mx: "auto", p: 3, backgroundColor: "#fff" }}>
        <GlobalNotification userId={userId} userRole={userRole} />
        <PageInstructions storageKey="profileInstructions">
          <strong>Complete or review your profile</strong> by filling in all
          required fields and any additional information that applies to you.
          <br />
          <strong>Note:</strong> Name, Gender, Ethnicity, Talent Type & Age are required
          before you can submit to a role.
          <br />
          When finished, click <strong>“Save Profile”</strong> at the bottom of
          the page, then proceed to the <strong>“My Resume”</strong> page to
          review or upload your photos, reels, and credits.
        </PageInstructions>
        {saved && (
          <Alert severity="success" sx={{ mb: 3 }}>
            Profile saved successfully.
          </Alert>
        )}

        {/* PERSONAL INFO */}
        <Section title="Personal Information">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              name="firstName"
              label="First Name"
              fullWidth
              required
              value={formData.firstName}
              onChange={handleChange}
              error={!!mandatoryErrors.firstName}
              helperText={mandatoryErrors.firstName}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              name="middleName"
              label="Middle Name"
              fullWidth
              value={formData.middleName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              name="lastName"
              label="Last Name"
              fullWidth
              required
              value={formData.lastName}
              onChange={handleChange}
              error={!!mandatoryErrors.lastName}
              helperText={mandatoryErrors.lastName}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              select
              name="sex"
              label="Gender"
              fullWidth
              required
              value={formData.sex}
              onChange={handleChange}
              error={!!mandatoryErrors.sex}
              helperText={mandatoryErrors.sex}
            >
              {SEX_OPTIONS.map((s) => (
                <MenuItem key={s} value={s}>
                  {s}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
<Grid item xs={12} sm={6} md={4}>
    <TextField
    select
    name="ethnicityCode"
    label="Ethnicity"
    fullWidth
    required
    value={formData.ethnicityCode}
    onChange={handleChange}
    error={!!mandatoryErrors.ethnicityCode}
    helperText={mandatoryErrors.ethnicityCode}
>
        {ethnicityOptions.map((item) => (
            <MenuItem
                key={item.ethnicityId}
                value={item.ethnicityId}
            >
                {item.ethnicityName}
            </MenuItem>
        ))}
    </TextField>
</Grid>
          <Grid item xs={12} sm={6} md={4}>
<CityAutocomplete
  city={formData.city}
  onSelect={({ city, stateCode, stateName, latitude, longitude }) =>
    setFormData((prev) => ({
      ...prev,
      city: city || "",
      stateCode: stateCode || "",
      stateName: stateName || "",
      latitude: latitude ?? null,
      longitude: longitude ?? null,
    }))
  }
  onClear={() =>
    setFormData((prev) => ({
      ...prev,
      city: "",
      stateName: "",
      stateCode: "",
      latitude: null,
      longitude: null,
    }))
  }
/>
            <Typography variant="caption">
              Fill in city and state will be automatically filled in.
            </Typography>
          </Grid>


          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="State"
              fullWidth
              value={formData.stateName}
              InputProps={{ readOnly: true }}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl
              fullWidth
              required
              error={!!mandatoryErrors.talentTypes}
              size="small"
            >
              <InputLabel id="talent-type-label">Talent Type</InputLabel>

              <Select
                labelId="talent-type-label"
                label="Talent Type"
                multiple
                value={selectedTalentIds || []}
                onChange={(e) => {
                  const value = e.target.value;

                  setSelectedTalentIds(value);

                  setSaved(false);

                  if (value.length) {
                    setMandatoryErrors((prev) => {
                      const updated = { ...prev };
                      delete updated.talentTypes;
                      return updated;
                    });
                  }
                }}
                renderValue={(selected) => (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      gap: 0.5,
                      alignItems: "center",
                    }}
                  >
                    {selected.map((id) => {
                      const t = talentTypeOptions.find(
                        (x) => x.talentId === id,
                      );
                      return (
                        <Chip
                          key={id}
                          label={t?.talentName || id}
                          size="small"
                          sx={{ maxWidth: 80 }}
                        />
                      );
                    })}
                  </Box>
                )}
                sx={{
                  height: 51.69,
                  "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                    overflow: "hidden",
                  },
                }}
              >
                {talentTypeOptions.map((t) => (
                  <MenuItem key={t.talentId} value={t.talentId}>
                    <Checkbox
                      checked={selectedTalentIds.includes(t.talentId)}
                    />
                    <ListItemText primary={t.talentName} />
                  </MenuItem>
                ))}
              </Select>

              {mandatoryErrors.talentTypes && (
                <Typography color="error" variant="caption">
                  {mandatoryErrors.talentTypes}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="ageRangeFrom"
              label="Age From"
              type="number"
              fullWidth
              required
              value={formData.ageRangeFrom}
              onChange={handleChange}
              inputProps={{ min: 0 }}
              error={!!mandatoryErrors.ageRangeFrom}
              helperText={mandatoryErrors.ageRangeFrom}
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              name="ageRangeTo"
              label="Age To"
              type="number"
              fullWidth
              required
              value={formData.ageRangeTo}
              onChange={handleChange}
              inputProps={{ min: 0 }}
              error={!!mandatoryErrors.ageRangeTo}
              helperText={mandatoryErrors.ageRangeTo}
            />
          </Grid>
        </Section>

        {/* CONTACT INFO */}
        <Section title="Contact Information">
          <Grid item xs={12} sm={6} md={4}>

<PhoneNumberField
  phoneNumber={formData.primaryPhone || ""}
  label="Primary Phone"
  onChange={({ phoneNumber }) => {
    setFormData((prev) => ({
      ...prev,
      primaryPhone: phoneNumber || "",
    }));
    setSaved(false);
    setErrors((prev) => ({
      ...prev,
      primaryPhone: !phoneNumber
        ? "Primary phone number is required"
        : !isValidPhone(phoneNumber)
          ? "Enter a valid phone number"
          : undefined,
    }));
  }}
  error={!!errors.primaryPhone}
  helperText={errors.primaryPhone}
  required
/>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
          <PhoneNumberField
  phoneNumber={formData.secondaryPhone || ""}
  label="Secondary Phone"
  onChange={({ phoneNumber }) => {
    setFormData((prev) => ({
      ...prev,
      secondaryPhone: phoneNumber || "",
    }));

    setSaved(false);

    setErrors((prev) => ({
      ...prev,
      secondaryPhone:
        phoneNumber && !isValidPhone(phoneNumber)
          ? "Enter a valid phone number"
          : undefined,
    }));
  }}
  error={!!errors.secondaryPhone}
  helperText={errors.secondaryPhone}
/>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="email"
              label="Email"
              fullWidth
              value={formData.email}
              disabled
            />
            <Typography variant="caption">
              Email id cannot be edited
            </Typography>
          </Grid>
        </Section>

        {/* SOCIAL */}
        <Section title="Social Links">
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="faceBook"
              label="FACEBOOK"
              fullWidth
              value={formData.faceBook}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="youTube"
              label="YOUTUBE"
              fullWidth
              value={formData.youTube}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="imdb"
              label="IMDB"
              fullWidth
              value={formData.imdb}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="snapChat"
              label="SNAPCHAT"
              fullWidth
              value={formData.snapChat}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="instagram"
              label="INSTAGRAM"
              fullWidth
              value={formData.instagram}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="tikTok"
              label="TIKTOK"
              fullWidth
              value={formData.tikTok}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="personalWebSite"
              label="WEBSITE"
              fullWidth
              value={formData.personalWebSite}
              onChange={handleChange}
            />
          </Grid>
        </Section>

        <Section title="Payment Links" sx={{ mb: 0 }}>
          {formData.paymentDetails.map((p, index) => (
            <Grid container spacing={2} key={index} sx={{ p: 2, pb: 0 }}>
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  label={`Payment Label ${index + 1}`}
                  fullWidth
                  value={p.label}
                  onChange={(e) =>
                    handlePaymentChange(index, "label", e.target.value)
                  }
                  placeholder="e.g. UPI, PayPal, Stripe"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  label={`Payment Link ${index + 1}`}
                  fullWidth
                  value={p.link}
                  onChange={(e) =>
                    handlePaymentChange(index, "link", e.target.value)
                  }
                  placeholder="https://..."
                />
              </Grid>
            </Grid>
          ))}
        </Section>
        {/* REPRESENTATION */}
        <Section title="Representation">
          <Typography sx={{ m: 2 }}>
            Complete this section only if you are formally represented by the
            listed agency and authorize them to negotiate employment offers on
            your behalf.
          </Typography>
          {repHeadings.map((h) => (
            <Grid
              container
              rowSpacing={2}
              columnSpacing={2}
              key={h}
              sx={{ m: 0 }}
            >
              <Grid item xs={12} sx={{ m: 0, pl: 2 }}>
                <Typography fontWeight={600}>{h}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Company"
                  fullWidth
                  value={representations[h]?.nameofCompany || ""}
                  onChange={(e) =>
                    handleRepChange(h, "nameofCompany", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Representative"
                  fullWidth
                  value={representations[h]?.representativeName || ""}
                  onChange={(e) =>
                    handleRepChange(h, "representativeName", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
      <PhoneNumberField
  phoneNumber={representations[h]?.representativeContact || ""}
  label="Phone Number"
  onChange={({ phoneNumber }) =>
    handleRepChange(
      h,
      "representativeContact",
      phoneNumber || ""
    )
  }
  error={!!repErrors[h]}
  helperText={repErrors[h]}
/>
              </Grid>
            </Grid>
          ))}
        </Section>

        <Box sx={{ textAlign: "right", mt: 3 }}>
          {!saved ? (
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={
                saving ||
                !!errors.primaryPhone ||
                !!errors.secondaryPhone ||
                hasRepPhoneErrors ||
                Object.keys(mandatoryErrors).length > 0
              }
            >
              {saving ? "Saving..." : "Save Profile"}
            </Button>
          ) : (
            <Button
              variant="contained"
              color="success"
              onClick={() => navigate("/myresume?mode=edit")}
            >
              Go to Resume
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

export default ProfilePage;